module.exports = __webpack_public_path__ + "static/client5-6644717652dec2a3972763578940a1f2.png";